
import { css } from '@emotion/core';

export default css`
  p, li {
    font-size: 1.4rem;
    margin-top: .5rem;
    margin-bottom: .5rem;
  }
`;